export default "__VITE_ASSET__tz2va42e__"